module.exports = __webpack_public_path__ + "img/historia_3-4.0f12f98f.jpg";